import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Returns a map of query parameters.
 */
export default function useUrlQuery() {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    return Object.fromEntries(params);
  }, [search]);
}
